import React, { useState } from "react";

import { IconButton, Tooltip } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { BsGear } from "react-icons/bs";

import Modal from "../../../Generic/Modal";
import DiagnosticsTest from "../../DiagnosticsTestModal";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";

const useStyles = makeStyles(() =>
  createStyles({
    iconButton: {
      padding: 0,
      marginLeft: "0.7rem",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:disabled": {
        opacity: 0.8,
      },
    },
    iconPointer: {
      cursor: "pointer",
    },
  })
);

const SettingsButton = () => {
  const { videoSurvey } = useVideoContext();
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [isOpenSettings, setIsOpenSettings] = useState<boolean>(false);

  return (
    <>
      <Tooltip title={translate("settings")}>
        <span>
          <IconButton
            className={classes.iconButton}
            data-cy="videoSurveySettingsIcon"
            onClick={() => setIsOpenSettings(true)}
          >
            <BsGear size={18} color="#475467" className={classes.iconPointer} />
          </IconButton>
        </span>
      </Tooltip>
      <Modal
        title={translate("settings")}
        open={isOpenSettings}
        handleClose={() => setIsOpenSettings(false)}
        data-cy="videoSurveySettingsModal"
      >
        <DiagnosticsTest
          isJoinVideoSurvey
          iceServers={videoSurvey?.iceServers}
          voiceToken={videoSurvey?.voiceToken}
        />
      </Modal>
    </>
  );
};

export default SettingsButton;
